import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import Airtable from 'airtable';

import { loggedIn, setAppState } from 'loot-core/client/actions';
import { type State } from 'loot-core/client/state-types';
import {
  init as initConnection,
  send,
} from 'loot-core/src/platform/client/fetch';

import { ProtectedRoute } from '../../auth/ProtectedRoute';
import { Permissions } from '../../auth/types';
import { getCoach } from '../../coaches/coachVariables';
import { useMetaThemeColor } from '../../hooks/useMetaThemeColor';
import { theme } from '../../style';
import { tokens } from '../../tokens';
import {
  BackToFileListButton,
  UserDirectoryPage,
} from '../admin/UserDirectory/UserDirectoryPage';
import { AppBackground } from '../AppBackground';
import { Text } from '../common/Text';
import { View } from '../common/View';
import { LoggedInUser } from '../LoggedInUser';
import { Notifications } from '../Notifications';
import { useResponsive } from '../responsive/ResponsiveProvider';
import { useMultiuserEnabled, useServerVersion } from '../ServerContext';

import { BudgetList } from './BudgetList';
import CoachQuiz from './coach_quiz';
import { ConfigServer } from './ConfigServer';
import { ServerURL } from './ServerURL';
import { Bootstrap } from './subscribe/Bootstrap';
import { ChangePassword } from './subscribe/ChangePassword';
import { Error } from './subscribe/Error';
import { Login } from './subscribe/Login';
import { OpenIdCallback } from './subscribe/OpenIdCallback';
import { WelcomeScreen } from './WelcomeScreen';

import ReactPixel from 'react-facebook-pixel';

export function NeedStuffApp({
  userData,
  setStateSomeDialogues,
  setStateInitialDialogueId,
}) {
  const [coachId, setCoachId] = useState(null);
  const [airtableCoachId, setAirtableCoachId] = useState(null);
  const [airtableStatus, setAirtableStatus] = useState(null);
  const [airtableStatusExpiresAt, setAirtableStatusExpiresAt] = useState(null);
  const [airtableZoomRate, setAirtableZoomRate] = useState(null);
  const [airtableZoomLink, setAirtableZoomLink] = useState(null);
  const [airtableStreamChatUserId, setAirtableStreamChatUserId] =
    useState(null);
  const [airtableCoachFirstName, setAirtableCoachFirstName] = useState(null);
  const [airtableFirstName, setAirtableFirstName] = useState(null);
  const [airtableEmail, setAirtableEmail] = useState(null);
  const [airtableAvatarFile, setAirtableAvatarFile] = useState(null);
  const [airtableAvatarPhoto, setAirtableAvatarPhoto] = useState(null);

  const [airtableUserPlan, setAirtableUserPlan] = useState(null);
  const [airtableCoachCalId, setAirtableCoachCalId] = useState(null);

  // const userData = useSelector((state: State) => state.user.data);
  const [airtableLastName, setAirtableLastName] = useState(null);
  const [airtableHeard, setAirtableHeard] = useState(null);

  const [needCoachData, setNeedCoachData] = useState(null);
  const [needUserData, setNeedUserData] = useState(null);

  async function init() {
    if (userData?.userId !== null) {
      const url = String(window.location.href);

      const storedParams = localStorage.getItem('urlParams');
      const params = storedParams ? JSON.parse(storedParams) : null;

      const results = await send('airtable-user', {
        url,
        coachId: params?.coach,
        coachSelectionSource:
          params?.coach_selection_source || 'directory_listing',
        utm_campaign: params?.utm_campaign,
        utm_medium: params?.utm_medium,
        utm_source: params?.utm_source,
        utm_term: params?.utm_term,
        utm_content: params?.utm_content,
        fprom_tid: params?.fprom_tid,
        fprom_ref: params?.fprom_ref,
      });

      if (!localStorage.getItem('registration_tracked')) {
        if (!window.location.hostname.includes('localhost')) {
          ReactPixel.init('476212184832855');
          ReactPixel.track('CompleteRegistration');
        }
        localStorage.setItem('registration_tracked', 'true');
      }

      const record = results.fields;

      console.log('record');
      //console.log(record);

      //const coach_id = record.get('coach_id')?.[0] || null;
      const coach_id = record.coach_id?.[0] || null;
      setAirtableCoachId(coach_id);

      //const status = record.get('status');
      const status = record.status;
      setAirtableStatus(status);

      const status_expires_at = record.status_expires_at;
      setAirtableStatusExpiresAt(status_expires_at);

      const coach_zoom_rate = record.coach_zoom_rate;
      setAirtableZoomRate(coach_zoom_rate);

      const coach_zoom_link = record.coach_zoom_link;
      setAirtableZoomLink(coach_zoom_link);

      const stream_chat_user_id = record.stream_chat_user_id;
      setAirtableStreamChatUserId(stream_chat_user_id);

      const coach_first_name = record.coach_first_name;
      setAirtableCoachFirstName(coach_first_name);

      const first_name = record.first_name;
      setAirtableFirstName(first_name);

      const email = record.email;
      setAirtableEmail(email);

      const avatar = record.coach_avatar?.[0]?.url || null;
      setAirtableAvatarFile(avatar);

      const coach_photo = record.coach_photo?.[0]?.base64 || null;
      setAirtableAvatarPhoto(coach_photo);

      const plan = record.plan;
      setAirtableUserPlan(plan);

      const coach_cal_id = record.coach_cal_user;
      setAirtableCoachCalId(coach_cal_id);

      const local_storage_sync = record.local_storage_sync;

      const last_name = record.last_name;
      setAirtableLastName(last_name);

      const found_us = record.found_us;
      setAirtableHeard(found_us);

      if (local_storage_sync !== undefined) {
        const data = JSON.parse(local_storage_sync);

        // Restore items
        Object.entries(data).forEach(([key, value]) => {
          try {
            // Store the value, ensuring it's properly serialized if it's an object
            const serializedValue =
              typeof value === 'object' ? JSON.stringify(value) : String(value);
            localStorage.setItem(key, serializedValue);
          } catch (error) {}
        });
      }

      //proxy for all coach stuff
      if (coach_id === null) {
        // this one has to be null and the below is undefined
        setNeedCoachData(true);
      } else if (found_us === undefined) {
        //not working as a check
        setNeedUserData(true);
      }
    }

    //await initAvatar();
  }

  useEffect(() => {
    async function wrapper() {
      await initAvatar();
    }

    if (
      airtableCoachId !== null &&
      airtableStatus !== null &&
      airtableStatusExpiresAt !== null &&
      airtableZoomRate !== null &&
      airtableZoomLink !== null &&
      airtableStreamChatUserId !== null &&
      airtableCoachFirstName !== null &&
      airtableFirstName !== null &&
      airtableEmail !== null &&
      airtableAvatarFile !== null &&
      airtableHeard !== undefined
    ) {
      wrapper();
    }
  }, [
    airtableCoachId,
    airtableStatus,
    airtableStatusExpiresAt,
    airtableZoomRate,
    airtableZoomLink,
    airtableStreamChatUserId,
    airtableCoachFirstName,
    airtableFirstName,
    airtableEmail,
    airtableAvatarFile,
    airtableHeard,
  ]);

  useEffect(() => {
    async function initAll() {
      await Promise.all([init()]);
      //dispatch(setAppState({ loadingText: null }));
    }

    initAll().catch();
  }, []);

  async function initAvatar() {
    const url = String(window.location.href);
    //url = "https://zackwhelchel.mybudgetcoach.app/";

    //return // add this when breaking.

    //const results = await send('env-variables', url:);
    //var myobj = JSON.parse(results);

    console.log('airtableAvatarFile');
    console.log(airtableAvatarFile);

    // let REACT_APP_BILLING_STATUS = myobj.data.REACT_APP_BILLING_STATUS;
    // let REACT_APP_TRIAL_END_DATE = myobj.data.REACT_APP_TRIAL_END_DATE;
    // let REACT_APP_START_PAYING_DATE = myobj.data.REACT_APP_START_PAYING_DATE;
    // let REACT_APP_ZOOM_RATE = myobj.data.REACT_APP_ZOOM_RATE;
    // let REACT_APP_ZOOM_LINK = myobj.data.REACT_APP_ZOOM_LINK;
    // let REACT_APP_CHAT_USER_ID = myobj.data.REACT_APP_CHAT_USER_ID;
    // let REACT_APP_COACH = myobj.data.REACT_APP_COACH;
    // let REACT_APP_COACH_FIRST_NAME = myobj.data.REACT_APP_COACH_FIRST_NAME;
    // let REACT_APP_USER_FIRST_NAME = myobj.data.REACT_APP_USER_FIRST_NAME;
    // let REACT_APP_USER_EMAIL = myobj.data.REACT_APP_USER_EMAIL;
    // let REACT_APP_UI_MODE = myobj.data.REACT_APP_UI_MODE;

    const REACT_APP_BILLING_STATUS = airtableStatus;
    const REACT_APP_TRIAL_END_DATE = airtableStatusExpiresAt;
    const REACT_APP_START_PAYING_DATE = airtableStatusExpiresAt;
    const REACT_APP_ZOOM_RATE = airtableZoomRate;
    const REACT_APP_ZOOM_LINK = airtableZoomLink;
    const REACT_APP_CHAT_USER_ID = airtableStreamChatUserId;
    const REACT_APP_COACH = airtableCoachId;
    const REACT_APP_COACH_FIRST_NAME = airtableCoachFirstName;
    const REACT_APP_USER_FIRST_NAME = airtableFirstName;
    const REACT_APP_USER_EMAIL = airtableEmail;
    const REACT_APP_UI_MODE =
      airtableStatus == 'coach_account' ? 'coach' : 'user';
    const REACT_APP_COACH_PHOTO = airtableAvatarPhoto; // this is new.

    const REACT_APP_USER_PLAN = airtableUserPlan;
    const REACT_APP_COACH_CAL_ID = airtableCoachCalId;

    if (REACT_APP_BILLING_STATUS != null) {
      localStorage.setItem(
        'REACT_APP_BILLING_STATUS',
        REACT_APP_BILLING_STATUS,
      );
    } else {
      localStorage.removeItem('REACT_APP_BILLING_STATUS');
    }

    if (REACT_APP_TRIAL_END_DATE != null) {
      localStorage.setItem(
        'REACT_APP_TRIAL_END_DATE',
        REACT_APP_TRIAL_END_DATE,
      );
    } else {
      localStorage.removeItem('REACT_APP_TRIAL_END_DATE');
    }

    if (REACT_APP_START_PAYING_DATE != null) {
      localStorage.setItem(
        'REACT_APP_START_PAYING_DATE',
        REACT_APP_START_PAYING_DATE,
      );
    } else {
      localStorage.removeItem('REACT_APP_START_PAYING_DATE');
    }

    if (REACT_APP_ZOOM_RATE != null) {
      localStorage.setItem('REACT_APP_ZOOM_RATE', REACT_APP_ZOOM_RATE);
    } else {
      localStorage.removeItem('REACT_APP_ZOOM_RATE');
    }

    if (REACT_APP_ZOOM_LINK != null) {
      localStorage.setItem('REACT_APP_ZOOM_LINK', REACT_APP_ZOOM_LINK);
    } else {
      localStorage.removeItem('REACT_APP_ZOOM_LINK');
    }

    if (REACT_APP_CHAT_USER_ID != null) {
      localStorage.setItem('REACT_APP_CHAT_USER_ID', REACT_APP_CHAT_USER_ID);
    } else {
      localStorage.removeItem('REACT_APP_CHAT_USER_ID');
    }

    if (REACT_APP_COACH != null) {
      localStorage.setItem('REACT_APP_COACH', REACT_APP_COACH);
    } else {
      localStorage.removeItem('REACT_APP_COACH');
    }

    if (REACT_APP_COACH_FIRST_NAME != null) {
      localStorage.setItem(
        'REACT_APP_COACH_FIRST_NAME',
        REACT_APP_COACH_FIRST_NAME,
      );
    } else {
      localStorage.removeItem('REACT_APP_COACH_FIRST_NAME');
    }

    if (REACT_APP_USER_FIRST_NAME != null) {
      localStorage.setItem(
        'REACT_APP_USER_FIRST_NAME',
        REACT_APP_USER_FIRST_NAME,
      );
    } else {
      localStorage.removeItem('REACT_APP_USER_FIRST_NAME');
    }

    if (REACT_APP_USER_EMAIL != null) {
      localStorage.setItem('REACT_APP_USER_EMAIL', REACT_APP_USER_EMAIL);
    } else {
      localStorage.removeItem('REACT_APP_USER_EMAIL');
    }

    if (REACT_APP_UI_MODE != null) {
      localStorage.setItem('REACT_APP_UI_MODE', REACT_APP_UI_MODE);
    } else {
      localStorage.removeItem('REACT_APP_UI_MODE');
    }

    if (REACT_APP_COACH_PHOTO != null) {
      localStorage.setItem('REACT_APP_COACH_PHOTO', REACT_APP_COACH_PHOTO);
    } else {
      localStorage.removeItem('REACT_APP_COACH_PHOTO');
    }

    if (REACT_APP_USER_PLAN != null) {
      localStorage.setItem('REACT_APP_USER_PLAN', REACT_APP_USER_PLAN);
    } else {
      localStorage.removeItem('REACT_APP_USER_PLAN');
    }

    if (REACT_APP_COACH_CAL_ID != null) {
      localStorage.setItem('REACT_APP_COACH_CAL_ID', REACT_APP_COACH_CAL_ID);
    } else {
      localStorage.removeItem('REACT_APP_COACH_CAL_ID');
    }

    //Set up the coach dialogues.
    let coachSrc = '/avatars/' + getCoach() + '.drawio.xml';

    // console.log("anita 1:", REACT_APP_COACH);
    // console.log("anita 1:", getCoach());
    coachSrc = airtableAvatarFile;

    type Conversation = {
      id: string;
      title: string;
      dialogues: Map;
      firstDialogueId: string;
      triggerType: string;
      canBeUserInitiated: boolean;
    };

    type Dialogue = {
      id: string;
      text: string;
      dialogueOptions: [DialogueOption];
      type: string; // choose, autoPush
      action: string;
      gif: string;
      context: string;
    };

    type DialogueOption = {
      toId: string;
      text: string;
      variableToSet: string;
      valueToSet: string;
      and: [Condition];
      or: [Condition];
      y: number;
    };

    type Condition = {
      and: [Condition];
      or: [Condition];
      variable: string;
      value: string;
      test: string;
    };

    //let someDialogues = new Map();
    const someConversations = new Map();
    const initialDialogueId = undefined;

    const file = localStorage.getItem('uploaded_draw_io_file');

    // console.log("I have a file here at setup");
    // console.log(file);

    // if (file != null) {
    //   coachSrc = file;
    // }

    const testPublishedAvatar = localStorage.getItem('test_published_avatar');
    if (testPublishedAvatar != null) {
      coachSrc = '/avatars/' + getCoach() + '.drawio.xml';
    }

    await fetch(coachSrc)
      .then(res => res.text())
      .then(xmlString => {
        let stringToUse = xmlString;
        const file = localStorage.getItem('uploaded_draw_io_file');

        if (file != null) {
          // console.log("still a file?????");

          stringToUse = file;
        }

        // console.log("go on xml?");
        // console.log(stringToUse);
        return new window.DOMParser().parseFromString(stringToUse, 'text/xml');
      })
      .then(data => {
        // I guess you could just set the dialogue id here... and run checks for triggers and such. idk.

        //console.log(data.getElementsByTagName("mxCell")[3].getAttribute("value"));

        //ok, how do I split these up based on tabs?

        const diagrams = data.getElementsByTagName('diagram');

        if (diagrams.length === 1) {
          // console.log("Um... hello");

          const items = diagrams[0].getElementsByTagName('mxCell');
          let [dialogues, firstDialogueId, triggerType, canBeUserInitiated] =
            dialoguesForConversation(items);

          // console.log("Um... hello");

          const id = diagrams[0].getAttribute('id');
          const name = diagrams[0].getAttribute('name');

          // console.log("Um... hello");

          canBeUserInitiated = true;

          const conversation: Conversation = {
            id,
            title: 'Introduction',
            dialogues,
            firstDialogueId,
            triggerType,
            canBeUserInitiated,
          };
          someConversations.set(conversation.id, conversation);

          // console.log("Um... hello" + conversation.id);
        } else {
          for (let i = 0; i < diagrams.length; i++) {
            const diagram = diagrams[i];

            const id = diagram.getAttribute('id');
            const name = diagram.getAttribute('name');

            const items = diagram.getElementsByTagName('mxCell');
            let [dialogues, firstDialogueId, triggerType, canBeUserInitiated] =
              dialoguesForConversation(items);

            if (name === 'Introduction') {
              canBeUserInitiated = true;
            }

            const conversation: Conversation = {
              id,
              title: name,
              dialogues,
              firstDialogueId,
              triggerType,
              canBeUserInitiated,
            };
            someConversations.set(conversation.id, conversation);
          }
        }

        //console.log(data);

        //someDialogues = dialoguesForConversation(data);
      })
      .catch(err => {
        console.log('err on xml?');
        console.log(err);
      });

    console.log('TOMLIN: ');
    console.log(someConversations);

    //someDialogues = someConversations;
    setStateSomeDialogues(someConversations);
    setStateInitialDialogueId(initialDialogueId);

    //await initChat(REACT_APP_CHAT_USER_ID, REACT_APP_CHAT_ACCESS_TOKEN, REACT_APP_UI_MODE);
  }

  function dialoguesForConversation(items): [Map, string, string, boolean] {
    const someDialogues = new Map();

    let triggerType = null;
    let canBeUserInitiated = false;

    let firstId = undefined;
    let firstIdXYTotal = 100000000;

    const actions = new Map();
    const gifs = new Map();

    for (let i = 0; i < items.length; i++) {
      const child = items[i];

      const id = child.getAttribute('id');
      let value = child.getAttribute('value');

      //Ok I think this might work... but... we need the <br> for the value saving.
      //Also the fact that labels are sometimes on the arrows themselves... are those set up to split and save variables too?
      //let div = document.createElement("div");
      //div.innerHTML = value;
      //value = div.innerHTML;//div.textContent || div.innerText || "";

      const style = child.getAttribute('style');

      let context = 'Anywhere';

      if (
        value !== undefined &&
        value !== null &&
        style !== undefined &&
        style !== null
      ) {
        //value = value.replaceAll(" style=\"([\\s\\S]+?)\"", "");

        // value = value.replaceAll('<br style="border-color: var(--border-color);">', '<br>');
        // value = value.replaceAll('<br style="border-color: var(--border-color); text-align: left;">', '<br>');
        // value = value.replaceAll('<br style="border-color: var(--border-color); font-style: normal;">', '<br>');
        // value = value.replaceAll('<div style="border-color: var(--border-color); font-style: normal;">', '<div>');
        // value = value.replaceAll('<i style="border-color: var(--border-color);">', '<i>');
        // value = value.replaceAll('<span style="border-color: var(--border-color);">', '<span>');
        // value = value.replaceAll('<div style="border-color: var(--border-color);">', '<div>');
        // value = value.replaceAll('<span style="font-style: normal; border-color: var(--border-color);">', '<span>');
        // value = value.replaceAll('<div style="">', '<div>');
        // value = value.replaceAll('<br style="border-color: var(--border-color);">', '<br>');
        // value = value.replaceAll('<div style="border-color: var(--border-color); text-align: left;">', '<div>');
        // value = value.replaceAll('<span style="border-color: var(--border-color); text-align: center;">', '<span>');
        // value = value.replaceAll('<span style="border-color: var(--border-color); background-color: initial;">', '<span>');
        // value = value.replaceAll('<div style="text-align: left;">', '<div>');
        // value = value.replaceAll('<span style="background-color: initial;">', '<span>');
        // value = value.replaceAll('<span style="text-align: left;">', '<span>');
        // value = value.replaceAll('<span style="">', '<span>');

        value = value.replaceAll(
          ' style="border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); text-align: left;"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); font-style: normal;"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); font-style: normal;"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(
          ' style="font-style: normal; border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(' style=""', '');
        value = value.replaceAll(
          ' style="border-color: var(--border-color);"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); text-align: left;"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); text-align: center;"',
          '',
        );
        value = value.replaceAll(
          ' style="border-color: var(--border-color); background-color: initial;"',
          '',
        );
        value = value.replaceAll(' style="text-align: left;"', '');
        value = value.replaceAll(' style="background-color: initial;"', '');
        value = value.replaceAll(' style="text-align: left;"', '');
        value = value.replaceAll(' style="font-size: 12px;"', '');
        value = value.replaceAll(' style="font-size: 10px;"', '');

        // value = value.replaceAll('border-color: var(--border-color);', '');
        // value = value.replaceAll('font-size: 12px;', '');
        // value = value.replaceAll('font-size: 10px;', '');
        // value = value.replaceAll('background-color: initial;', '');
        // value = value.replaceAll('font-style: normal;', '');

        // value = value.replaceAll('<font style="font-size: 12px;">', '');
        // value = value.replaceAll('<font style="font-size: 10px;">', '');
        // value = value.replaceAll('</font>', '');
        // value = value.replaceAll('<p>', '');
        // value = value.replaceAll('</p>', '');
        // value = value.replaceAll('<i>', '');
        // value = value.replaceAll('</i>', '');
        // value = value.replaceAll('<font>', '');
        // value = value.replaceAll('</font>', '');
        // value = value.replaceAll('<span>', '');
        // value = value.replaceAll('</span>', '');
        // value = value.replaceAll('<div>', '');
        // value = value.replaceAll('</div>', '');

        // if (value.endsWith("<br>")) {
        //   value = value.substring(0, value.length - 4);
        // }
        // if (value.endsWith("<br>")) {
        //   value = value.substring(0, value.length - 4);
        // }
        // if (value.endsWith("<br>")) {
        //   value = value.substring(0, value.length - 4);
        // }
        // if (value.endsWith("<br>")) {
        //   value = value.substring(0, value.length - 4);
        // }
        // if (value.endsWith("<br>")) {
        //   value = value.substring(0, value.length - 4);
        // }

        //end any trailing <br> s, this is so dumb...

        // console.log(value);

        const sIndex = value.indexOf('&lt;&lt;') + 8;
        const tIndex = value.indexOf('&gt;&gt;');

        //&amp;lt;&amp;lt;Budget&amp;gt;&amp;gt;&lt;br style=&quot;border-color: var(--border-color);&quot;&gt;&lt;br&gt;
        if (value.includes('&lt;&lt;')) {
          // console.log("dumb");
          // console.log(value);

          const substringToReplace = value.substring(sIndex, tIndex);
          value = value.replace(
            '&lt;&lt;' + substringToReplace + '&gt;&gt;',
            '',
          );
          value = value.replace('<br>', '');
          value = value.replace('<br>', '');
          context = substringToReplace;
        }

        value = value.replaceAll('&nbsp;', ' ');

        if (
          style.includes('shape=mxgraph.flowchart.decision;') ||
          style.startsWith('rounded=0;') ||
          style.startsWith('whiteSpace=wrap;html=1;') ||
          style.startsWith('rhombus;') ||
          style.startsWith(
            'html=1;whiteSpace=wrap;aspect=fixed;shape=isoRectangle;',
          )
        ) {
          const moreChilds = child.getElementsByTagName('mxGeometry');

          for (let i = 0; i < moreChilds.length; i++) {
            const moreChild = moreChilds[i];

            const xxx = moreChild.getAttribute('x');
            const yyy = moreChild.getAttribute('y');

            if (
              xxx !== null &&
              xxx !== undefined &&
              yyy !== null &&
              yyy !== undefined
            ) {
              const xyTotal = Number(xxx) + Number(yyy);

              // console.log("id xy total:" + id + " " + xyTotal);

              if (xyTotal < firstIdXYTotal) {
                firstIdXYTotal = xyTotal;
                firstId = id;
              }
            }
          }

          const dia: Dialogue = {
            id,
            text: value,
            dialogueOptions: [],
            type: 'choose',
            context,
          };
          someDialogues.set(dia.id, dia);

          // console.log(value);
        } else if (style.startsWith('shape=cylinder3;')) {
          const moreChilds = child.getElementsByTagName('mxGeometry');

          for (let i = 0; i < moreChilds.length; i++) {
            const moreChild = moreChilds[i];

            const xxx = moreChild.getAttribute('x');
            const yyy = moreChild.getAttribute('y');

            if (
              xxx !== null &&
              xxx !== undefined &&
              yyy !== null &&
              yyy !== undefined
            ) {
              const xyTotal = Number(xxx) + Number(yyy);

              // console.log("id xy total:" + id + " " + xyTotal);

              if (xyTotal < firstIdXYTotal) {
                firstIdXYTotal = xyTotal;
                firstId = id;
              }
            }
          }

          const dia: Dialogue = {
            id,
            text: '',
            dialogueOptions: [],
            type: 'autoPush',
            context,
          };
          someDialogues.set(dia.id, dia);

          // console.log(value);
        } else if (style.startsWith('shape=step;perimeter=stepPerimeter;')) {
          const xxx = child.getAttribute('value');
          // console.log('thetriggerthing' + xxx);
          triggerType = xxx;

          if (style.includes('fillColor=#e1d5e7;')) {
            canBeUserInitiated = true;
          }
        } else if (style.startsWith('rounded=1')) {
          //Ok I think this might work... but... we need the <br> for the value saving.
          //Also the fact that labels are sometimes on the arrows themselves... are those set up to split and save variables too?
          // let div = document.createElement("div");
          // div.innerHTML = value;
          // value = div.textContent || div.innerText || "";
          value = value.replaceAll('</div><div>', '<br>');
          value = value.replaceAll('<div>', '');
          value = value.replaceAll('</div>', '');

          value = value.replaceAll('<font>', '');
          value = value.replaceAll('</font>', '');
          value = value.replaceAll('<p>', '');
          value = value.replaceAll('</p>', '');
          value = value.replaceAll('<i>', '');
          value = value.replaceAll('</i>', '');
          value = value.replaceAll('<font>', '');
          value = value.replaceAll('</font>', '');
          value = value.replaceAll('<span>', '');
          value = value.replaceAll('</span>', '');
          value = value.replaceAll('<div>', '');
          value = value.replaceAll('</div>', '');

          actions.set(id, value);

          // save this as an action.
        } else if (style.startsWith('triangle')) {
          gifs.set(id, value);

          // save this as an action.
        }
      }
    }

    const optionInfo = new Map();
    for (let i = 0; i < items.length; i++) {
      const child = items[i];

      const id = child.getAttribute('id');
      const style = child.getAttribute('style');
      let value = child.getAttribute('value');
      const parent = child.getAttribute('parent');

      if (
        parent !== undefined &&
        parent !== null &&
        style !== undefined &&
        style !== null &&
        value !== undefined &&
        value !== null
      ) {
        value = value.replaceAll('&nbsp;', ' ');

        if (style.startsWith('edgeLabel;')) {
          optionInfo.set(parent, value);
        }
      }
    }

    for (let i = 0; i < items.length; i++) {
      const child = items[i];

      const id = child.getAttribute('id');
      const value = child.getAttribute('value');
      const style = child.getAttribute('style');
      const source = child.getAttribute('source');
      const target = child.getAttribute('target');

      //mxGeometry -> mxPoint -> y; //idk, maybe.

      let y = 0;

      const moreChilds = child.getElementsByTagName('mxPoint');

      for (let i = 0; i < moreChilds.length; i++) {
        const moreChild = moreChilds[i];

        const newy = moreChild.getAttribute('y');
        if (newy > y) {
          y = newy;
        }
      }

      if (source === 'iygmyBO8lgVPopkCsqYT-73') {
        console.log('y: ' + y + ' _ ' + id);
      }

      if (
        source !== undefined &&
        source !== null &&
        style !== undefined &&
        style !== null
      ) {
        //should conditionally put this here too...
        // value = value.replaceAll("&nbsp;", " ");

        if (
          style.startsWith('edgeStyle=orthogonalEdgeStyle;') ||
          style.startsWith('edgeStyle=elbowEdgeStyle;shape=connector;') ||
          style.startsWith('edgeStyle=none;shape=connector;') ||
          style.startsWith('rounded=0;orthogonalLoop=1') ||
          style.startsWith('endArrow=classic;') ||
          style.startsWith('edgeStyle=none;rounded=0;orthogonalLoop=1') ||
          style.startsWith(
            'edgeStyle=none;curved=1;rounded=0;orthogonalLoop=1;',
          )
        ) {
          if (style.includes('dashed=1;')) {
          } else {
            const sourceAction = actions.get(source);
            if (sourceAction !== undefined && sourceAction !== null) {
              const dialogue = someDialogues.get(target);

              if (dialogue !== undefined && dialogue !== null) {
                dialogue.action = sourceAction;
              }
            }

            const sourceGif = gifs.get(source);
            if (sourceGif !== undefined && sourceGif !== null) {
              const dialogue = someDialogues.get(target);

              if (dialogue !== undefined && dialogue !== null) {
                dialogue.gif = sourceGif;
              }
            }

            const dialogue = someDialogues.get(source);

            if (dialogue !== undefined) {
              // ok so we have an arrow... does the dialogue it comes from have a type of auto? because then we'll interpret a bit differently...

              if (dialogue.type === 'choose') {
                let stuff = optionInfo.get(id);

                if (value !== null && value !== undefined && value.length > 0) {
                  stuff = value;
                }

                if (stuff !== null && stuff !== undefined) {
                  //ok we need to see if there is a second line here...
                  if (stuff.includes('<br')) {
                    let stuff1 = '';
                    let stuff2 = '';

                    const longStr =
                      '<br style="border-color: var(--border-color);">';

                    if (stuff.includes('<br>')) {
                      stuff1 = stuff.substring(0, stuff.indexOf('<br>'));
                      stuff2 = stuff.substring(stuff.indexOf('<br>') + 4);
                    } else if (stuff.includes(longStr)) {
                      // console.log("ever made it here?")
                      stuff1 = stuff.substring(0, stuff.indexOf(longStr));
                      stuff2 = stuff.substring(
                        stuff.indexOf(longStr) + longStr.length,
                      );
                    }

                    const stuff1div = document.createElement('div');
                    stuff1div.innerHTML = stuff1;
                    stuff1 = stuff1div.textContent || stuff1div.innerText || '';

                    const stuff2div = document.createElement('div');
                    stuff2div.innerHTML = stuff2;
                    stuff2 = stuff2div.textContent || stuff2div.innerText || '';

                    const stuff3 = stuff2.substring(0, stuff2.indexOf(' = '));
                    const stuff4 = stuff2.substring(stuff2.indexOf(' = ') + 3);

                    const dia: DialogueOption = {
                      toId: target,
                      text: stuff1,
                      variableToSet: stuff3,
                      valueToSet: stuff4,
                      y,
                    };
                    dialogue.dialogueOptions.push(dia);
                    // console.log("Adding " + source + " to " + target + " and setting: " + stuff3 + " to " + stuff4);
                  } else {
                    const stuffdiv = document.createElement('div');
                    stuffdiv.innerHTML = stuff;
                    stuff = stuffdiv.textContent || stuffdiv.innerText || '';

                    const dia: DialogueOption = {
                      toId: target,
                      text: stuff,
                      y,
                    };
                    dialogue.dialogueOptions.push(dia);
                    // console.log("Adding " + source + " to " + target);
                  }
                } else {
                  const dia: DialogueOption = {
                    toId: target,
                    text: 'Next',
                    y,
                  };
                  dialogue.dialogueOptions.push(dia);
                  // console.log("Adding " + source + " to " + target);
                }
              } else if (dialogue.type === 'autoPush') {
                const stuff = optionInfo.get(id);
                if (stuff !== null && stuff !== undefined) {
                  const dialogueOption: DialogueOption = {
                    toId: target,
                    and: [],
                    or: [],
                    y,
                  };

                  // stuff -> parsed into ands and ors...

                  if (stuff.includes('AND')) {
                    let stuff1 = stuff.substring(0, stuff.indexOf(' AND '));
                    let stuff2 = stuff.substring(stuff.indexOf(' AND ') + 5);

                    if (!stuff1.includes('(')) {
                      //we know its an expression only.

                      const more1 = stuff1.substring(0, stuff1.indexOf(' = '));
                      const more2 = stuff1.substring(stuff1.indexOf(' = ') + 3);

                      const condition: Condition = {
                        and: [],
                        or: [],
                        variable: more1,
                        value: more2,
                        test: '=',
                      };

                      dialogueOption.and.push(condition);
                    } else {
                      //need to drill it more.

                      stuff1 = stuff1.replaceAll('(', '');
                      stuff1 = stuff1.replaceAll(')', '');

                      const conditionA: Condition = {
                        and: [],
                        or: [],
                      };

                      const more1 = stuff1.substring(0, stuff1.indexOf(' OR '));
                      const more2 = stuff1.substring(
                        stuff1.indexOf(' OR ') + 4,
                      );

                      const mas1 = more1.substring(0, more1.indexOf(' = '));
                      const mas2 = more1.substring(more1.indexOf(' = ') + 3);

                      const mas3 = more2.substring(0, more2.indexOf(' = '));
                      const mas4 = more2.substring(more2.indexOf(' = ') + 3);

                      const conditionB: Condition = {
                        and: [],
                        or: [],
                        variable: mas1,
                        value: mas2,
                        test: '=',
                      };

                      const conditionC: Condition = {
                        and: [],
                        or: [],
                        variable: mas3,
                        value: mas4,
                        test: '=',
                      };

                      conditionA.or.push(conditionB);
                      conditionA.or.push(conditionC);
                      dialogueOption.and.push(conditionA);
                    }

                    if (!stuff2.includes('(')) {
                      //we know its an expression only.

                      const more1 = stuff2.substring(0, stuff2.indexOf(' = '));
                      const more2 = stuff2.substring(stuff2.indexOf(' = ') + 3);

                      const condition: Condition = {
                        and: [],
                        or: [],
                        variable: more1,
                        value: more2,
                        test: '=',
                      };

                      dialogueOption.and.push(condition);
                    } else {
                      //need to drill it more.

                      stuff2 = stuff2.replaceAll('(', '');
                      stuff2 = stuff2.replaceAll(')', '');

                      const conditionA: Condition = {
                        and: [],
                        or: [],
                      };

                      const more1 = stuff2.substring(0, stuff2.indexOf(' OR '));
                      const more2 = stuff2.substring(
                        stuff2.indexOf(' OR ') + 4,
                      );

                      const mas1 = more1.substring(0, more1.indexOf(' = '));
                      const mas2 = more1.substring(more1.indexOf(' = ') + 3);

                      const mas3 = more2.substring(0, more2.indexOf(' = '));
                      const mas4 = more2.substring(more2.indexOf(' = ') + 3);

                      const conditionB: Condition = {
                        and: [],
                        or: [],
                        variable: mas1,
                        value: mas2,
                        test: '=',
                      };

                      const conditionC: Condition = {
                        and: [],
                        or: [],
                        variable: mas3,
                        value: mas4,
                        test: '=',
                      };

                      conditionA.or.push(conditionB);
                      conditionA.or.push(conditionC);
                      dialogueOption.and.push(conditionA);
                    }
                  } else {
                    // the simple case needs covered too.

                    if (stuff.includes(' = ')) {
                      const more1 = stuff.substring(0, stuff.indexOf(' = '));
                      const more2 = stuff.substring(stuff.indexOf(' = ') + 3);

                      const condition: Condition = {
                        and: [],
                        or: [],
                        variable: more1,
                        value: more2,
                        test: '=',
                      };

                      dialogueOption.and.push(condition);
                    } else if (stuff.includes(' &gt; ')) {
                      const more1 = stuff.substring(0, stuff.indexOf(' &gt; '));
                      const more2 = stuff.substring(
                        stuff.indexOf(' &gt; ') + 6,
                      );

                      const condition: Condition = {
                        and: [],
                        or: [],
                        variable: more1,
                        value: more2,
                        test: '>',
                      };

                      dialogueOption.and.push(condition);
                    } else if (stuff.includes(' &lt; ')) {
                      const more1 = stuff.substring(0, stuff.indexOf(' &lt; '));
                      const more2 = stuff.substring(
                        stuff.indexOf(' &lt; ') + 6,
                      );

                      const condition: Condition = {
                        and: [],
                        or: [],
                        variable: more1,
                        value: more2,
                        test: '<',
                      };

                      dialogueOption.and.push(condition);
                    }
                  }

                  dialogue.dialogueOptions.push(dialogueOption);
                  // console.log("Adding " + source + " to " + target + " and CONDITIONS FOR AUTOPUSH");
                  // console.log(dialogue);
                }
              }
            }
          }
        }
      }
    }

    const keys = someDialogues.keys();

    for (const [key, value] of someDialogues.entries()) {
      const dialogue = value;
      dialogue.dialogueOptions.sort(function (a, b) {
        return a.y - b.y; // no idea why the minus is used here but it worked.
      });
    }

    //go through all of these someDialogues
    //and resort their dialogue options by ys.

    //setAllDialogues(someDialogues);
    const initialDialogueId = firstId;

    //return someDialogues;

    //so here you have all the some dialogues... they all have actions... etc...

    const updatedDialogueData = addProgressToDialogue(
      someDialogues,
      initialDialogueId,
    );

    return [
      updatedDialogueData,
      initialDialogueId,
      triggerType,
      canBeUserInitiated,
    ];
  }

  /**
   * Adds a progress percentage to each node in a dialogue Map object,
   * with improved cycle detection to prevent infinite loops.
   *
   * @param {string} dialogueMapStr - The dialogue data as a Map constructor string
   * @return {string} - The updated dialogue data with progress values added
   */
  function addProgressToDialogue(dialogueMapStr, startNodeId) {
    try {
      // Parse the dialogue data into a Map, then convert to a plain object
      const dialogueMap = eval(dialogueMapStr);
      const dialogueNodes = {};

      dialogueMap.forEach((value, key) => {
        dialogueNodes[key] = { ...value };
      });

      // Find the start node (node with no incoming connections)
      // const startNodeId = findStartNode(dialogueNodes);

      // Find all end nodes (nodes with no outgoing connections or null toId)
      const endNodes = findEndNodes(dialogueNodes);

      console.log(`Start node: ${startNodeId}`);
      console.log(`End nodes: ${Array.from(endNodes).join(', ')}`);

      // Build a graph representation for better cycle detection
      const graph = buildGraph(dialogueNodes);

      // Calculate max possible depth (with cycle detection)
      const nodeDepths = calculateNodeDepthsWithCycleDetection(
        graph,
        startNodeId,
      );
      const maxDepth = Math.max(...Object.values(nodeDepths));

      console.log(`Maximum depth: ${maxDepth}`);

      // Calculate distance to end nodes (with cycle detection)
      const nodeDistancesToEnd = calculateDistancesToEnd(graph, endNodes);
      const maxDistance = Math.max(
        ...Object.values(nodeDistancesToEnd).filter(d => d < Infinity),
      );

      console.log(`Maximum distance to end: ${maxDistance}`);

      // Calculate progress for each node
      for (const nodeId in dialogueNodes) {
        // Handle nodes that are part of cycles differently
        const depth = nodeDepths[nodeId] || 0;
        const distanceToEnd =
          nodeDistancesToEnd[nodeId] === Infinity
            ? maxDistance
            : nodeDistancesToEnd[nodeId];

        // Progress based on depth from start
        const depthProgress = Math.round((depth / maxDepth) * 100);

        // Progress based on distance to end
        const distanceProgress = Math.round(
          ((maxDistance - distanceToEnd) / maxDistance) * 100,
        );

        // Combine the two metrics with a weighting factor
        const weightFactor = depth / maxDepth;
        const progress = Math.round(
          weightFactor * distanceProgress + (1 - weightFactor) * depthProgress,
        );

        // Ensure progress is within valid range
        dialogueNodes[nodeId].progress = Math.max(0, Math.min(100, progress));
      }

      // Set specific values for start and end nodes
      dialogueNodes[startNodeId].progress = 0;
      endNodes.forEach(nodeId => {
        dialogueNodes[nodeId].progress = 100;
      });

      // Handle nodes in cycles more explicitly
      handleCyclicNodes(dialogueNodes, graph, startNodeId, endNodes);

      // Smooth out progress values to avoid large jumps between connected nodes
      smoothProgressValues(dialogueNodes, graph, startNodeId);

      // Rescale progress values to use the full 0-100 range
      rescaleProgress(dialogueNodes, startNodeId, endNodes);

      // Convert back to a Map
      const updatedMap = new Map();
      for (const nodeId in dialogueNodes) {
        updatedMap.set(nodeId, dialogueNodes[nodeId]);
      }

      // Convert the Map to a string similar to the input format
      return updatedMap;
    } catch (error) {
      console.error('Error processing dialogue data:', error);
      return dialogueMapStr; // Return original on error
    }
  }

  /**
   * Builds a directed graph representation of the dialogue.
   * This makes cycle detection and traversal more efficient.
   */
  function buildGraph(dialogueNodes) {
    const graph = {
      outgoing: {}, // outgoing edges: nodeId -> [childNodeIds]
      incoming: {}, // incoming edges: nodeId -> [parentNodeIds]
    };

    // Initialize all nodes
    for (const nodeId in dialogueNodes) {
      if (!graph.outgoing[nodeId]) graph.outgoing[nodeId] = [];
      if (!graph.incoming[nodeId]) graph.incoming[nodeId] = [];
    }

    // Add edges
    for (const nodeId in dialogueNodes) {
      const node = dialogueNodes[nodeId];
      if (node.dialogueOptions) {
        for (const option of node.dialogueOptions) {
          if (option.toId) {
            // Add outgoing edge
            graph.outgoing[nodeId].push(option.toId);

            // Add incoming edge
            if (!graph.incoming[option.toId]) {
              graph.incoming[option.toId] = [];
            }
            graph.incoming[option.toId].push(nodeId);
          }
        }
      }
    }

    return graph;
  }

  /**
   * Finds the start node (node with no incoming connections).
   */
  function findStartNode(dialogueNodes) {
    const incomingConnections = new Set();

    // Collect all nodes that are referenced as destinations
    for (const nodeId in dialogueNodes) {
      const node = dialogueNodes[nodeId];
      if (node.dialogueOptions) {
        node.dialogueOptions.forEach(option => {
          if (option.toId) {
            incomingConnections.add(option.toId);
          }
        });
      }
    }

    // The start node is likely the one that isn't referenced as a destination
    for (const nodeId in dialogueNodes) {
      if (!incomingConnections.has(nodeId)) {
        return nodeId;
      }
    }

    // Fallback to the first node if no clear start is found
    return Object.keys(dialogueNodes)[0];
  }

  /**
   * Finds all end nodes (nodes with no outgoing connections or null toId).
   */
  function findEndNodes(dialogueNodes) {
    const endNodes = new Set();

    for (const nodeId in dialogueNodes) {
      const node = dialogueNodes[nodeId];
      if (
        !node.dialogueOptions ||
        node.dialogueOptions.length === 0 ||
        node.dialogueOptions.every(option => option.toId === null)
      ) {
        endNodes.add(nodeId);
      }
    }

    return endNodes;
  }

  /**
   * Calculates node depths with cycle detection using breadth-first search.
   * This avoids getting stuck in cycles.
   */
  function calculateNodeDepthsWithCycleDetection(graph, startNodeId) {
    const depths = {};
    const queue = [{ id: startNodeId, depth: 0 }];
    const visited = new Set();

    while (queue.length > 0) {
      const { id, depth } = queue.shift();

      // Skip if we've already found a shorter path to this node
      if (visited.has(id) && depths[id] <= depth) {
        continue;
      }

      // Update depth
      depths[id] = Math.min(depths[id] || Infinity, depth);
      visited.add(id);

      // Add all children to the queue
      for (const childId of graph.outgoing[id] || []) {
        // Only visit if we haven't found a shorter path yet
        if (!visited.has(childId) || depths[childId] > depth + 1) {
          queue.push({ id: childId, depth: depth + 1 });
        }
      }
    }

    return depths;
  }

  /**
   * Calculates the minimum distance from each node to any end node.
   * Uses Dijkstra's algorithm with cycle detection.
   */
  function calculateDistancesToEnd(graph, endNodes) {
    const distances = {};
    const processed = new Set();

    // Initialize distances
    for (const nodeId in graph.outgoing) {
      distances[nodeId] = Infinity;
    }

    // End nodes have distance 0
    for (const endNodeId of endNodes) {
      distances[endNodeId] = 0;
    }

    // Process all nodes
    const allNodes = Object.keys(graph.outgoing);

    while (processed.size < allNodes.length) {
      // Find the unprocessed node with minimum distance
      let minDistance = Infinity;
      let currentNode = null;

      for (const nodeId in distances) {
        if (!processed.has(nodeId) && distances[nodeId] < minDistance) {
          minDistance = distances[nodeId];
          currentNode = nodeId;
        }
      }

      // If no nodes can reach an end node, break
      if (!currentNode || minDistance === Infinity) {
        break;
      }

      processed.add(currentNode);

      // Update distances of incoming nodes
      for (const parentId of graph.incoming[currentNode] || []) {
        if (!processed.has(parentId)) {
          const newDistance = distances[currentNode] + 1;
          if (newDistance < distances[parentId]) {
            distances[parentId] = newDistance;
          }
        }
      }
    }

    return distances;
  }

  /**
   * Detects nodes that are part of cycles and handles their progress values.
   */
  function handleCyclicNodes(dialogueNodes, graph, startNodeId, endNodes) {
    // Find strongly connected components (cycles)
    const cycles = findStronglyConnectedComponents(graph);

    console.log(`Found ${cycles.length} cycles in the dialogue graph`);

    for (const cycle of cycles) {
      if (cycle.length <= 1) continue; // Skip single-node cycles

      console.log(`Handling cycle: ${cycle.join(', ')}`);

      // Calculate the average progress of nodes connected to this cycle
      const connectedNodes = new Set();

      // Add nodes that lead into the cycle
      for (const nodeId of cycle) {
        for (const parentId of graph.incoming[nodeId] || []) {
          if (!cycle.includes(parentId)) {
            connectedNodes.add(parentId);
          }
        }
      }

      // Add nodes that the cycle leads to
      for (const nodeId of cycle) {
        for (const childId of graph.outgoing[nodeId] || []) {
          if (!cycle.includes(childId)) {
            connectedNodes.add(childId);
          }
        }
      }

      // Calculate average progress of connected nodes
      let totalProgress = 0;
      let count = 0;

      for (const nodeId of connectedNodes) {
        totalProgress += dialogueNodes[nodeId].progress;
        count++;
      }

      const avgProgress = count > 0 ? totalProgress / count : 50; // Default to 50% if no connections

      // Apply a slightly different progress to each node in the cycle
      // to maintain a sense of progression
      cycle.forEach((nodeId, index) => {
        // Distribute progress values within ±5% of the average
        const offset = (index / (cycle.length - 1)) * 10 - 5;
        dialogueNodes[nodeId].progress = Math.max(
          0,
          Math.min(100, Math.round(avgProgress + offset)),
        );
      });
    }
  }

  /**
   * Finds strongly connected components (cycles) in the graph using Kosaraju's algorithm.
   */
  function findStronglyConnectedComponents(graph) {
    const visited = new Set();
    const finished = [];
    const components = [];

    // First DFS pass
    function dfs1(node) {
      if (visited.has(node)) return;
      visited.add(node);

      for (const neighbor of graph.outgoing[node] || []) {
        dfs1(neighbor);
      }

      finished.push(node);
    }

    // Second DFS pass
    function dfs2(node, component) {
      if (!visited.has(node)) return;
      visited.delete(node);
      component.push(node);

      for (const neighbor of graph.incoming[node] || []) {
        dfs2(neighbor, component);
      }
    }

    // First pass - fill the finished array
    for (const node in graph.outgoing) {
      dfs1(node);
    }

    // Second pass - find components
    while (finished.length > 0) {
      const node = finished.pop();
      if (!visited.has(node)) continue;

      const component = [];
      dfs2(node, component);

      if (component.length > 0) {
        components.push(component);
      }
    }

    return components;
  }

  /**
   * Smooths progress values to avoid large jumps between connected nodes.
   */
  function smoothProgressValues(dialogueNodes, graph, startNodeId) {
    // Sort nodes by topological order (as much as possible, given cycles)
    const sorted = topologicalSort(graph, startNodeId);

    // Multiple passes to propagate smoother values
    for (let pass = 0; pass < 3; pass++) {
      for (const nodeId of sorted) {
        const node = dialogueNodes[nodeId];
        const progress = node.progress;

        // Smooth forward (children)
        for (const childId of graph.outgoing[nodeId] || []) {
          const childNode = dialogueNodes[childId];

          // Child should be slightly more progressed than parent
          const minExpectedProgress = progress + 1;
          const maxExpectedProgress = progress + 15;

          if (childNode.progress < minExpectedProgress) {
            childNode.progress = minExpectedProgress;
          } else if (childNode.progress > maxExpectedProgress) {
            childNode.progress = maxExpectedProgress;
          }
        }

        // Smooth backward (parents) - but with less effect
        for (const parentId of graph.incoming[nodeId] || []) {
          const parentNode = dialogueNodes[parentId];

          // Parent should be slightly less progressed than this node
          const maxExpectedParentProgress = progress - 1;

          if (parentNode.progress > maxExpectedParentProgress) {
            // Only pull back by half to avoid destabilizing
            parentNode.progress = Math.round(
              (parentNode.progress + maxExpectedParentProgress) / 2,
            );
          }
        }
      }
    }
  }

  /**
   * Performs a topological sort of the graph nodes.
   * For nodes within cycles, order is arbitrary but deterministic.
   */
  function topologicalSort(graph, startNodeId) {
    const visited = new Set();
    const result = [];

    function visit(nodeId) {
      if (visited.has(nodeId)) return;
      visited.add(nodeId);

      for (const childId of graph.outgoing[nodeId] || []) {
        visit(childId);
      }

      result.unshift(nodeId);
    }

    // Start with the start node
    visit(startNodeId);

    // Process any nodes not reachable from start
    for (const nodeId in graph.outgoing) {
      visit(nodeId);
    }

    return result;
  }

  /**
   * Rescales progress values to ensure full range utilization from 0 to 100.
   */
  function rescaleProgress(dialogueNodes, startNodeId, endNodes) {
    // Find min and max progress values (excluding start and end nodes)
    let minProgress = 100;
    let maxProgress = 0;

    for (const nodeId in dialogueNodes) {
      if (nodeId !== startNodeId && !endNodes.has(nodeId)) {
        minProgress = Math.min(minProgress, dialogueNodes[nodeId].progress);
        maxProgress = Math.max(maxProgress, dialogueNodes[nodeId].progress);
      }
    }

    // Only rescale if there's a meaningful range
    if (maxProgress > minProgress) {
      const range = maxProgress - minProgress;

      for (const nodeId in dialogueNodes) {
        if (nodeId !== startNodeId && !endNodes.has(nodeId)) {
          const normalizedProgress =
            ((dialogueNodes[nodeId].progress - minProgress) / range) * 98;
          dialogueNodes[nodeId].progress = Math.round(normalizedProgress + 1); // Range from 1 to 99
        }
      }
    }

    // Ensure start node is 0% and end nodes are 100%
    dialogueNodes[startNodeId].progress = 0;
    for (const nodeId of endNodes) {
      dialogueNodes[nodeId].progress = 100;
    }
  }

  if (needCoachData === true) {
    return (
      <View style={{ height: '100%', color: 'black' }}>
        <CoachQuiz
          jumpToUser={false}
          firstName={airtableFirstName}
          lastName={airtableLastName}
          email={airtableEmail}
        />
      </View>
    );
  }
  if (needUserData === true) {
    return (
      <View style={{ height: '100%', color: 'black' }}>
        <CoachQuiz
          jumpToUser={true}
          firstName={airtableFirstName}
          lastName={airtableLastName}
          email={airtableEmail}
        />
      </View>
    );
  }

  const imgSrc = '/maskable-192x192.png';

  const bg = (
    <View style={{ height: '100%' }}>
      <AppBackground />
      <View
        style={{
          height: '100%',
        }}
      >
        <img
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '75px',
            position: 'absolute',
            margin: 'auto',
            top: '0px',
            left: '0px',
            bottom: '0px',
            right: '0px',
          }}
          src={imgSrc}
          alt="coach"
        />
      </View>
    </View>
  );

  return bg;
}
